import DealerTableHelper from './dealer-table-helper';


const DealerHelpers = {
    TableMain: DealerTableHelper,
}

export default DealerHelpers;